import { Button, Tooltip } from "@heroui/react";
import { useFileUploadModal } from "./useFileUploadModal";
import { Link } from "react-router-dom";
import { S3_URL } from "@/api/s3";
import { FaEye, FaUpload } from "react-icons/fa6";

export function FileUploadField({
  label,
  value,
  onChange,
  isInvalid,
  errorMessage,
}: {
  label: string;
  onChange: (value: string) => void;
  isInvalid: boolean;
  value?: string;
  errorMessage?: string;
}) {
  const uploadModal = useFileUploadModal();

  return (
    <>
      <uploadModal.FileUploadModal
        accept="*"
        multiple={false}
        onFileUploaded={(val) => onChange(val[0])}
      />
      <div className="flex flex-col gap-2">
        <span className="text text-foreground">{label}</span>
        <div className="flex flex-row items-center gap-2">
          {value && (
            <>
              <span className="text-sm text-foreground">{value}</span>
              <Tooltip content="Просмотреть файл">
                <Button
                  as={Link}
                  to={`${S3_URL}/${value}`}
                  target="_blank"
                  isIconOnly
                  variant="flat"
                  color="default"
                  size="sm"
                  startContent={<FaEye />}
                />
              </Tooltip>
            </>
          )}
          <Tooltip content={value ? "Заменить файл" : "Загрузить файл"}>
            <Button
              onPress={uploadModal.onOpen}
              isIconOnly
              variant="flat"
              color="default"
              size="sm"
              startContent={<FaUpload />}
            />
          </Tooltip>
        </div>
        {isInvalid && errorMessage && (
          <span className="text-red-500 text-sm">{errorMessage}</span>
        )}
      </div>
    </>
  );
}
